module.exports = {"create":"Crear Partner Manager","createDescription":"crea un user Partner Manager","success":"Partner Manager creado con éxito"};